import SectionHeading from "@/components/base/SectionHeading";
import PrinciplesGrid from "@/components/feature/PrinciplesGrid";

export default function PrinciplesSection() {
  return (
    <section
      id="principles"
      className="bg-background-50 py-14 md:py-20 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="内容原则"
          title="热闹可以看，底线不能丢"
          desc="围观是一种乐趣，也是一种责任。这四条是我们在整理每一篇内容时都会遵守的原则。"
        />
        <div className="mt-8">
          <PrinciplesGrid />
        </div>
      </div>
    </section>
  );
}